export default {
  strokeColor: '#29c4a9',
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: '#e9fde8',
  fillOpacity: 0.20,
  radius: 25 * 100,
  clickable: false,
  draggable: true,
  editable: true
}
